import script from "./gameLogView.vue?vue&type=script&setup=true&lang=ts"
export * from "./gameLogView.vue?vue&type=script&setup=true&lang=ts"

import "./gameLogView.vue?vue&type=style&index=0&id=be6c8464&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be6c8464"]])

export default __exports__